import { render, staticRenderFns } from "./pagamento.vue?vue&type=template&id=406776c7&scoped=true&"
import script from "./pagamento.vue?vue&type=script&lang=js&"
export * from "./pagamento.vue?vue&type=script&lang=js&"
import style0 from "./pagamento.vue?vue&type=style&index=0&id=406776c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406776c7",
  null
  
)

export default component.exports